import Vue from 'vue'
import $api from './api'

let common = {
  isRunningInStandalone: function () {
    var isInWebAppiOS = (window.navigator.standalone == true)
    var isInWebAppChrome = (window.matchMedia('(display-mode: standalone)').matches)
    return isInWebAppiOS || isInWebAppChrome
  },
  openPopupWindow: function (url, options) {
    if (!options) {
      options = {};
    }
    if (!options.name) {
      options.name = 'mywindow';
    }
    window.open(url, options.name, "width=500,height=400");
  },
  replaceLocation: function (url) {
    window.location.replace(url);
  },
  openBlankWindow: function(url) {
    window.open(url, "_blank");
  },
  openExternalLink: function(url) {
    if (this.isRunningInStandalone()) {
      this.openPopupWindow(url);
    } else {
      this.openBlankWindow(url);
    }
  },
  isDevEnv: function() {
    return process.env && process.env.NODE_ENV == 'development';
  },
  onError: function(err) {
    var logError = false
    // Check if its a js/type err e.g. a wrong function call or null pointer exception
    if (err instanceof TypeError) {
      logError = true
    }
    if (err instanceof $api.APIError) {
      logError = true
    }
    if (logError) {
      if (console.error) {
        console.error(err)
      } else {
        console.log(err)
      }
    }
  }
}

Vue.prototype.$common = common

export default common
